import { render, staticRenderFns } from "./IconRefresh.vue?vue&type=template&id=91063d66&scoped=true&"
import script from "./IconRefresh.vue?vue&type=script&lang=js&"
export * from "./IconRefresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91063d66",
  null
  
)

export default component.exports